import { createAction } from 'Utility/Redux';

enum Types {
    HELPER_FRIEND_REQUEST = 'helperFriendsRequest',
    HELPER_FRIEND_RESPONSE = 'helperFriendsResponse',
}

export const HelperFriendActions = {
    helperFriendRequest: createAction(
        Types.HELPER_FRIEND_REQUEST,
        resolve => (friendId: string) => resolve(friendId)
    ),
    helperFriendResponse: createAction(
        Types.HELPER_FRIEND_RESPONSE,
        resolve => (success: boolean, friendId?: string) =>
            resolve({ success, friendId })
    ),
};
